<template>
    <div>
        <div class="white-box-container smp-component-width text-left">
            <h3 style="font-weight: bold;">
                Bulk Device Creation
            </h3>
            <p style="margin-top: 2rem;">Create multiple devices using a xls file or a range of serial number</p>
            <b-tabs content-class="mt-3">
                <b-tab title="XLS Upload" active>
                    <XLSUploadComponent></XLSUploadComponent>
                </b-tab>
                <b-tab title="Range">
                    <RangeUploadComponent ></RangeUploadComponent>
                </b-tab>
            </b-tabs>
        </div>
    </div>
</template>

<script>
import XLSUploadComponent from '../../components/bulk_creation/XLSUploadComponent.vue'
import RangeUploadComponent from '../../components/bulk_creation/RangeUploadComponent.vue'

export default {
  	data () {
		return {
            remove_group_selected: false,
		}
    },

	components: {
        XLSUploadComponent,
        RangeUploadComponent
	},

	watch: {

	},

	mounted () {
		console.log('GroupDeviceSoftware mounted')
	},

	methods: {
	}
}
</script>

<style lang="stylus" scoped>

</style>